export default __webpack_public_path__ + "static/media/sports24.7d406934.jpg";